import * as ActionTypes from './actionType.js';


const reducerMap = {
    /**
     * 获得题目列表
     * **/
    [ActionTypes.getQuestionListRequest]: (state, payload) => {
        return Object.assign({}, state, {
            isGetQuestionFetching:true
        });
    },
    [ActionTypes.getQuestionListFailure]: (state, payload) => {
        return Object.assign({}, state, {
            isGetQuestionFetching:true
        });
    },


    [ActionTypes.getQuestionListSuccess]: (state, payload) => {
        return Object.assign({}, state, {
            data:payload.data,
            isGetQuestionFetching:false
        });
    },


}
export const INITIALIZE_STATE = {
    data: {
        list: [],
        page: 1,
        task: {},
        pagesize: 10,
        total: 1,
    },
    isGetQuestionFetching:false,
    delQuestionstate:'failure'
}
export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/reducer.js